<template>
  <div class="page_judge_myMatches">
    <h1>{{ 'myMatches' | cz }}</h1>
    <h2 v-if="activeMatch != null">
      <a :href="`#teams?highlight=${activeMatch.teamAId}`">{{ activeMatch.teamA | team_name_full }}</a>
      vs.
      <a :href="`#teams?highlight=${activeMatch.teamBId}`">{{ activeMatch.teamB | team_name_full }}</a>
    </h2>
    <div v-if="activeMatch != null" class="active">
      <label for="active_field">Hřiště</label>
      <dropdown id="active_field" :items="fields" @change="setField">
        <template v-slot:label>{{ activeMatch.fieldId != null ? fields[activeMatch.fieldId].name : "Zvolte hřiště" }}</template>
        <template v-slot:item="{ item }">{{ item.name }}</template>
      </dropdown>
      <button v-if="!activeMatch.isStarted && activeMatch.fieldId != null" class="startMatch" @click="startMatch">Začít zápas</button>
      <template v-else-if="activeMatch.isStarted">
        <label for="active_scoreA">Skóre {{ activeMatch.teamA | team_name_full }}</label>
        <div class="score">
          <button v-for="(_, score) in 3" :key="score" :class="{ active: activeMatch.scoreA == score }" @click="setScore('A', score)">{{ score }}</button>
        </div>
        <label for="active_scoreB">Skóre {{ activeMatch.teamB | team_name_full }}</label>
        <div class="score">
          <button v-for="(_, score) in 3" :key="score" :class="{ active: activeMatch.scoreB == score }" @click="setScore('B', score)">{{ score }}</button>
        </div>
      </template>
    </div>
    <template v-for="matchCategory in relevantMatchCategories">
      <h2>{{ matchCategory.title }}</h2>
      <tabloid :name="matchCategory.name" :class="matchCategory.name" :columns="matchCategory.columns" :data="matchCategory.matches" defaultOrderBy="order">
        <template v-slot:teamA="{ row }">
          {{ row | bracket_team_name_a }}
        </template>
        <template v-slot:scoreA="{ value }">
          {{ value }}
        </template>
        <template v-slot:teamB="{ row }">
          {{ row | bracket_team_name_b }}
        </template>
        <template v-slot:scoreB="{ value }">
          {{ value }}
        </template>
        <template v-slot:winner="{ value }">
          {{ value | team_name_full }}
        </template>
        <template v-slot:bracket="{ value }">
          {{ value | emptyOrName }}
        </template>
        <template v-slot:category="{ value }">
          {{ value | cz }}
        </template>
        <template v-slot:field="{ value }">
          {{ value | emptyOrName }}
        </template>
        <template v-slot:judge="{ value }">
          {{ value | emptyOrName }}
        </template>
        <template v-slot:transmittingJudge="{ value }">
          {{ value | emptyOrName }}
        </template>
        <template v-slot:actions="{ row }">
          <template v-if="matchCategory.name == 'transmitMatches'">
            <button class="accept" @click="accept(row)" title="Přijmout"><i class="fas fa-gavel"></i></button>
            <button class="decline" @click="declineOrCancel(row)" title="Odmítnout"><i class="fas fa-times"></i></button>
          </template>
          <template v-if="row.canSetScore">
            <button class="activate" title="Aktivovat zápas" @click="activate(row)"><i class="fas fa-gavel"></i></button>
          </template>
          <template v-if="matchCategory.name == 'notPlayedMatches'">
            <dropdown :items="otherJudges" @change="(value, key) => selectTransmit(row, key)">
              <template v-slot:label>{{ transmitMatchId == row.id ? otherJudges[transmitJudgeId].name : "Předat" }}</template>
              <template v-slot:item="{ item }">{{ item.name }}</template>
            </dropdown>
            <button v-if="transmitMatchId == row.id" class="transmit" @click="transmit">Předat</button>
          </template>
          <template v-if="matchCategory.name == 'transmitByMeMatches'">
            <button class="cancel" @click="declineOrCancel(row)" title="Zrušit předání"><i class="fas fa-times"></i></button>
          </template>
        </template>
      </tabloid>
    </template>
  </div>
</template>
  
<script>
import { mapState } from "vuex";
import { _ } from "../../extend";
import dropdown from "../../components/dropdown.vue";
import tabloid from "../../components/tabloid.vue";

export default {
  name: "judge_myMatches",
  components: {
    dropdown,
    tabloid,
  },
  data: () => ({
    matchCategories: [
      {
        name: "transmitMatches",
        title: "Předávané pro mne",
        columns: {
          order: { title: '#' },
          teamA: { title: "1. tým", orderBy: value => value.id },
          scoreA: { title: "Skóre 1. týmu" },
          teamB: { title: "2. tým", orderBy: value => value.id },
          scoreB: { title: "Skóre 2. týmu" },
          bracket: { title: "Skupina", orderBy: value => value.name },
          category: { title: "Kategorie" },
          field: { title: "Hřiště", orderBy: value => value != null ? value.name : null },
          judge: { title: "Předáváno od", orderBy: value => value.name },
          actions: { title: "" },
        },
        filter: (m, myId) => m.transmittingJudgeId == myId,
      },
      {
        name: "notPlayedMatches",
        title: "Neodehrané zápasy",
        columns: {
          order: { title: '#' },
          teamA: { title: "1. tým", orderBy: value => value.id },
          scoreA: { title: "Skóre 1. týmu" },
          teamB: { title: "2. tým", orderBy: value => value.id },
          scoreB: { title: "Skóre 2. týmu" },
          winner: { title: "Vítěz" },
          bracket: { title: "Skupina", orderBy: value => value.name },
          category: { title: "Kategorie" },
          field: { title: "Hřiště", orderBy: value => value != null ? value.name : null },
          actions: { title: "" },
        },
        filter: (m, myId) => m.judgeId == myId && m.transmittingJudgeId == null && m.winnerId == null,
      },
      {
        name: "transmitByMeMatches",
        title: "Předávané mnou",
        columns: {
          order: { title: '#' },
          teamA: { title: "1. tým", orderBy: value => value.id },
          scoreA: { title: "Skóre 1. týmu" },
          teamB: { title: "2. tým", orderBy: value => value.id },
          scoreB: { title: "Skóre 2. týmu" },
          bracket: { title: "Skupina", orderBy: value => value.name },
          category: { title: "Kategorie" },
          field: { title: "Hřiště", orderBy: value => value != null ? value.name : null },
          transmittingJudge: { title: "Předáváno komu", orderBy: value => value.name },
          actions: { title: "" },
        },
        filter: (m, myId) => m.judgeId == myId && m.transmittingJudgeId != null,
      },
      {
        name: "playedMatches",
        title: "Odehrané zápasy",
        columns: {
          order: { title: '#' },
          teamA: { title: "1. tým" },
          scoreA: { title: "Skóre 1. týmu" },
          teamB: { title: "2. tým" },
          scoreB: { title: "Skóre 2. týmu" },
          winner: { title: "Vítěz" },
          bracket: { title: "Skupina" },
          category: { title: "Kategorie" },
          field: { title: "Hřiště" },
          actions: { title: "" },
        },
        filter: (m, myId) => m.judgeId == myId && m.transmittingJudgeId == null && m.winnerId != null,
      },
      {
        name: "transmittedByMeMatches",
        title: "Předáno",
        columns: {
          order: { title: '#' },
          teamA: { title: "1. tým", orderBy: value => value.id },
          scoreA: { title: "Skóre 1. týmu" },
          teamB: { title: "2. tým", orderBy: value => value.id },
          scoreB: { title: "Skóre 2. týmu" },
          bracket: { title: "Skupina", orderBy: value => value.name },
          category: { title: "Kategorie" },
          field: { title: "Hřiště", orderBy: value => value != null ? value.name : null },
          judge: { title: "Předáno komu", orderBy: value => value.name },
          actions: { title: "" },
        },
        filter: (m, myId) => m.judgeId != myId && m.canSetScore,
      },
    ],
    activeMatchId: null,
    transmitMatchId: null,
    transmitJudgeId: null,
  }),
  computed: {
    ...mapState(['fields']),
    activeMatch() {
      return this.$store.getters.matchesWithRelatedData[this.activeMatchId];
    },
    activeMatchTeams() {
      if (this.activeMatch == null) {
        return;
      }

      var teams = {
        [this.activeMatch.teamAId]: this.$store.state.teams[this.activeMatch.teamAId],
        [this.activeMatch.teamBId]: this.$store.state.teams[this.activeMatch.teamBId],
      };

      return teams;
    },
    otherJudges() {
      var other = _.filter(this.$store.state.users, u => u.id != this.myJudgeId);
      return other;
    },
    relevantMatchCategories() {
      const result = this.matchCategories
        .map(mc => ({ ...mc, matches: _.filter(this.$store.getters.matchesWithRelatedData, m => mc.filter(m, this.myJudgeId)) }))
        .filter(mc => Object.keys(mc.matches).length > 0);
      return result;
    },
    myJudgeId() {
      return this.$store.state.login.id;
    },
  },
  methods: {
    accept(match) {
      this.$store.commit("update", {
        paths: ['matches', match.id, 'judgeId'],
        value: this.myJudgeId,
      });
      this.$store.commit("update", {
        paths: ['matches', match.id, 'transmittingJudgeId'],
        value: null,
      });
      this.$store.dispatch('save');
    },
    declineOrCancel(match) {
      this.$store.commit("update", {
        paths: ['matches', match.id, 'transmittingJudgeId'],
        value: null,
      });
      this.$store.dispatch('save');
    },
    activate(match) {
      this.activeMatchId = match.id;
    },
    selectTransmit(match, judgeId) {
      this.transmitMatchId = match.id;
      this.transmitJudgeId = judgeId;
    },
    transmit() {
      var match = this.$store.getters.matchesWithRelatedData[this.transmitMatchId];
      this.$store.commit("update", {
        paths: ['matches', match.id, 'transmittingJudgeId'],
        value: this.transmitJudgeId,
      });
      this.$store.dispatch('save');
    },
    setField(field, fieldId) {
      this.$store.commit("update", {
        paths: ['matches', this.activeMatch.id, 'fieldId'],
        value: fieldId,
      });
      this.$store.dispatch('save');
    },
    startMatch() {
      this.$store.commit("update", {
        paths: ['matches', this.activeMatch.id, 'isStarted'],
        value: true,
      });
      this.$store.dispatch('save');
    },
    setScore(team, score) {
      this.$store.commit("update", {
        paths: ['matches', this.activeMatch.id, `score${team}`],
        value: score,
      });
      // set winner
      if (score == 2) {
        this.$store.commit("update", {
          paths: ['matches', this.activeMatch.id, 'winnerId'],
          value: this.activeMatch[`team${team}`].id,
        });
        this.activeMatchId = null
      }

      this.$store.dispatch('save');
    },

    getNextMatch() {
      var firstMatch = _.first(this.$store.getters.matchesWithRelatedData, m => m.winnerId == null);
      this.activeMatchId = firstMatch != null
        ? firstMatch.id
        : null;
    },
  },
  mounted() {
    this.getNextMatch();
  }
};
</script>
  
<style lang="sass">
@import ../../sass/_constants
@import ../../sass/_components

.page_judge_myMatches
  @include table-view()

  .active
    display: grid
    margin: 0 auto
    width: 100%
    max-width: $w-content
    grid-template-columns: 1fr 2fr
    grid-gap: .5rem
    label
      grid-column: 1
      align-self: center
      text-align: right
    .startMatch
      grid-column: 1 / 3
      @include button-primary()
    .score 
      display: grid
      grid-auto-flow: column

      button
        @include button-secondary()
        @include middle-input()
        &:first-child
          @include first-input()
        &:last-child
          @include last-input()
        &.active
          background-color: $bc-primary

  table
    &.transmitMatches
      td[data-columnname=actions]
        display: grid
        grid-auto-flow: column
      tr
        background-color: $bc-warning

    td[data-columnname=actions]
      display: grid
      justify-content: center
      grid-auto-flow: column

    .activate
      @include button-primary()
    .accept
      @include button-primary()
      @include first-input()
    .decline
      @include button-danger()
      @include last-input()
    .transmit
      @include button-secondary()
    .cancel
      @include button-danger()
  </style>